
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom ScrollRestoration component that scrolls to top on route changes
 * This replaces the built-in ScrollRestoration which requires a data router
 */
const ScrollRestoration = () => {
  // Safely try to use the router hook
  let pathname = '/';
  
  try {
    const location = useLocation();
    pathname = location.pathname;

    // Scroll to top when pathname changes
    useEffect(() => {
      window.scrollTo(0, 0);
      console.log('ScrollRestoration: Scrolled to top on navigation to', pathname);
    }, [pathname]);
  } catch (e) {
    console.warn('ScrollRestoration: No router context available');
    
    // If no router is available, just scroll to top once on mount
    useEffect(() => {
      window.scrollTo(0, 0);
      console.log('ScrollRestoration: Scrolled to top on initial render');
    }, []);
  }

  return null; // This component doesn't render anything
};

export default ScrollRestoration;
